(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionCheckoutWizard", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/subscriptionCheckoutWizardView.html",
            controller: ["subscriptionCheckoutService", "frameworkService", "$state", "$timeout", SubscriptionCheckoutWizardCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCheckoutWizardCtrl(subscriptionCheckoutService, frameworkService, $state, $timeout) {
            var vm = this;
            if (subscriptionCheckoutService.model.userCount === 0 || subscriptionCheckoutService.model.userCount > 1000) {
                $state.go("main.settings.subscription");
                return;
            }
            vm.isLoading = true;
            vm.frameworkData = frameworkService.data;
            vm.wizard = subscriptionCheckoutService.wizard;
            $timeout(function () {
                if ($state.current.name === "main.settings.subscriptionCheckout") {
                    $state.go("main.settings.subscription");
                    return;
                }
                vm.isLoading = false;
            });
            //this does not work in a directive, use $timeout instead
            //$scope.$on("$viewContentLoaded", function () {
            //	if ($state.current.name === "main.settings.subscriptionCheckout") {
            //		$state.go("main.settings.subscription");
            //		return;
            //	}
            //	vm.isLoading = false;
            //});
        }
    });
}());
